import { OverlayTrigger } from 'react-bootstrap'
import './ScheduleOverlay.scss'
import { convertDecimalMinutesToMMSS, getFormatedTime } from '../../../utils/commonFunctions'

const ScheduleOverlay = ({ Events }: { Events: any[] }) => {

    return (
        <div className="schedule__overLay__container">
            {Events.map((event, index) => {
                return (
                    <div className="schedule__overLay__card" key={`schedule-${index}`}>
                        <OverlayTrigger
                            key={`schedule-${index}`}
                            placement="auto"
                            overlay={
                                <div className='schedule__overLay__card__body'>
                                    <div className='d-flex w-100 align-items-center justify-content-between'>
                                        <div className='card_info'>
                                            <span className='fs-13'>{event?.['startTime'] && getFormatedTime(event?.['startTime'])} UTC</span>
                                            <span className='fs-12 opacity-50'>Start Time</span>
                                        </div>
                                        <div className='card_info align__end'>
                                            <span className='fs-13'>{event?.['startTime'] && getFormatedTime(event?.['endTime'])} UTC</span>
                                            <span className='fs-12 opacity-50'>End Time</span>
                                        </div>
                                    </div>
                                    <div className='d-flex w-100 align-items-center justify-content-between'>
                                        <div className='card_info'>
                                            <span className='fs-13'>{(event?.['endTime'] && event?.['startTime']) && `${convertDecimalMinutesToMMSS((event?.['endTime'] / 60) - (event?.['startTime'] / 60))}`}</span>
                                            <span className='fs-12 opacity-50'>Total Duration</span>
                                        </div>
                                        {event?.['properties']?.['freqBand'] &&
                                            <div className='card_info align__end'>
                                                <span className='fs-13 d-flex gap-1'>
                                                    {event?.['properties']?.['freqBand'].map((band: string) =>
                                                        <span key={`band-${band}`} className={`contact__status__badge band`}>{band.replace('-', ' ')}</span>
                                                    )}
                                                </span>
                                                <span className='fs-12 opacity-50'>Bands</span>
                                            </div>
                                        }
                                    </div>
                                </div>
                            }
                        >
                            <div className='schedule__overLay__card__header'>
                                <div className='d-flex flex-column align-items-start w-50'>
                                    <span className='w-98 text-truncate fs-13' title={event?.['taskName']}>{event?.['taskName']}</span>
                                    <span className='fs-12 opacity-50'>Task</span>
                                </div>
                                <div className='d-flex flex-column align-items-end w-50'>
                                    <span className='fs-13 text-truncate w-98 text-end' title={event?.['type'] === 'Contact Task' ? event?.['properties']?.['groundStationName'] : event?.['properties']?.['payloadName']}>{event?.['type'] === 'Contact Task' ? event?.['properties']?.['groundStationName'] : event?.['properties']?.['payloadName']}</span>
                                    <span className='fs-12 opacity-50'>{event?.['type'] === 'Contact Task' ? 'Ground Station' : 'Payload Name'}</span>
                                </div>
                            </div>
                        </OverlayTrigger>
                    </div>
                )
            })}
        </div>
    )
}

export default ScheduleOverlay